import React, { useState } from 'react';

export default function GameOptions({ onStart, isLoading, advancedOptions, presetOptions, genreOptions }) {
    const [mode, setMode] = useState('simple');
    const [genre, setGenre] = useState(genreOptions[0]);
    const [goal, setGoal] = useState(advancedOptions[0]?.goal || '');
    const [selectedScene, setSelectedScene] = useState(presetOptions[0]?.key || '');

    const handleSubmit = (e) => {
        e.preventDefault();
        const options = { mode };
        if (mode === 'simple') {
            options.genre = genre;
        } else if (mode === 'advanced') {
            options.genre = genre;
            options.goal = goal;
        } else if (mode === 'preset') {
            options.scene = selectedScene;
        }
        onStart(options);
    };

    return (
        <div className="card">
            <div className="card-header">
                <ul className="nav nav-tabs card-header-tabs">
                    <li className="nav-item">
                        <a className={`nav-link ${mode === 'simple' ? 'active' : ''}`} href="#" onClick={(e) => { e.preventDefault(); setMode('simple'); }}>Simple</a>
                    </li>
                    <li className="nav-item">
                        <a className={`nav-link ${mode === 'advanced' ? 'active' : ''}`} href="#" onClick={(e) => { e.preventDefault(); setMode('advanced'); }}>Advanced</a>
                    </li>
                    <li className="nav-item">
                        <a className={`nav-link ${mode === 'preset' ? 'active' : ''}`} href="#" onClick={(e) => { e.preventDefault(); setMode('preset'); }}>Preset</a>
                    </li>
                </ul>
            </div>
            <div className="card-body">
                <form onSubmit={handleSubmit}>
                    {mode === 'simple' && (
                        <div className="form-group">
                            <label htmlFor="genre-select">Genre:</label>
                            <select id="genre-select" value={genre} onChange={(e) => setGenre(e.target.value)} className="form-control">
                                {genreOptions.map(g => <option key={g} value={g}>{g}</option>)}
                            </select>
                        </div>
                    )}
                    {mode === 'advanced' && (
                        <>
                            <div className="form-group">
                                <label htmlFor="genre-select-adv">Genre:</label>
                                <select id="genre-select-adv" value={genre} onChange={(e) => setGenre(e.target.value)} className="form-control">
                                    {genreOptions.map(g => <option key={g} value={g}>{g}</option>)}
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="goal-select">Writing Goal:</label>
                                <select id="goal-select" value={goal} onChange={(e) => setGoal(e.target.value)} className="form-control">
                                    {advancedOptions.map(opt => <option key={opt.goal} value={opt.goal}>{opt.goal} - {opt.description}</option>)}
                                </select>
                            </div>
                        </>
                    )}
                    {mode === 'preset' && (
                        <div className="form-group">
                            <label htmlFor="scene-select">Choose a Scene:</label>
                            <select id="scene-select" value={selectedScene} onChange={(e) => setSelectedScene(e.target.value)} className="form-control">
                                {presetOptions.map(scene => <option key={scene.key} value={scene.key}>{scene.name}</option>)}
                            </select>
                        </div>
                    )}
                    <button type="submit" disabled={isLoading} className="btn btn-primary btn-block">
                        {isLoading ? 'Starting...' : 'Start Scene'}
                    </button>
                </form>
            </div>
        </div>
    );
}

